// Every English string the client shows, keyed, so translation (Later) is a file and not a refactor
// (design 7 §6.1). Score item names follow the Riichi module's registry (mjcore riichi.h, Item).

export const t = {
  appName: "mahhua",
  dealer: "Dealer",
  siteTitle: "mahhua",
  yourTurnTitle: "● Your turn · mahhua",
  ronFrom: (who: string) => `Ron from ${who}`,
  form: {
    title: (n: number) => `Your last ${n} games`,
    place: "Average place",
    review: "Review your latest unreviewed game",
    leak: {
      danger: (n: number, of: number) => `To work on: ${n} of your last ${of} costly decisions were discards too dangerous for the hand.`,
      discard: (n: number, of: number) => `To work on: ${n} of your last ${of} costly decisions were about which tile to let go.`,
      call: (n: number, of: number) => `To work on: ${n} of your last ${of} costly decisions were about calling or declaring riichi.`,
    } as Record<string, (n: number, of: number) => string>,
  },
  pressAgain: "Press again to discard",
  invited: (host: string) => `${host} invited you to a game of riichi mahjong`,
  invitedSeats: (n: number) => `${n} of 4 seated. Bots take any empty seats when the game starts.`,
  inviteStarted: "That game has already started. Ask your friend for a new link, or play now.",
  inviteFull: "That table is full. Ask your friend for a new link, or play now.",
  inviteClosed: "The host closed that table. Ask them for a new link, or play now.",
  inviteEnded: "That game has ended.",
  inviteBad: "That link doesn't lead to a table: ask your friend for a new one.",
  joinAsGuest: "Join as a guest",
  riichiChoose: "Riichi: choose the tile to discard",
  holdToPress: "Hold",
  holdPracticeLead: "Try the hold: press this and keep your finger on it, or hold P on a keyboard. With a mouse, one press is enough.",
  holdPracticeIdle: "Hold me",
  holdPracticeShort: "A moment longer",
  holdPracticeDone: "That's the hold",
  tagline: "Riichi mahjong at a real table, and a review that shows why every decision was right or wrong.",
  playNow: "Play now",
  trustLine: "Free · No ads · WRC and Tenhou rules",
  landingStills: [
    { caption: "A table that calls riichi as riichi is called", alt: "The table at a riichi: the call in katakana by the seat that made it, the scores on the compass in the centre." },
    { caption: "A review that says why, in words", alt: "A review's decision: a blunder, the hand's tiles with a bar over each, and the reasons in sentences." },
    { caption: "Every hand's score, yaku by yaku", alt: "A hand's result: a baiman for 16,000 points, the winning hand, and each yaku in kanji and romaji with its han." },
  ],
  experienceQuestion: "How well do you know riichi mahjong?",
  experienceLead: "Your first game is against three bots: East only, about 20 to 30 minutes. It does not count towards any rating, and you can leave it whenever you like.",
  experience: {
    new: { title: "New to riichi", text: "Ten short lessons on the table come first, and you can leave them at any point. Then the game, with plenty of time and help on the table." },
    rules: { title: "I know the rules", text: "The game starts right away, with plenty of time and help on the table." },
    elsewhere: { title: "I play elsewhere", text: "The game starts right away, on the standard clock, with no help." },
  },
  guestTitle: "Playing as a guest",
  guestText: "Your games are kept in this browser's account for 30 days. Sign in to keep them for good, add friends and open a table for them.",
  signInToKeep: "Sign in to keep this game",
  hints: {
    close: "Close",
    firstTurn: "Your turn: press a tile, or drag it up, to discard it.",
    firstTurnTouch: "Your turn: press a tile twice to discard it, or drag it up.",
    bank: "Your time for this move is up: your bank for this hand is running now.",
    ready: "You are ready: these tiles win your hand.",
    readyNoYaku: "You are waiting on these tiles, but your hand has no yaku: as it stands, none of them would win it.",
    readyNoRon: "You are ready, but your hand has no yaku on a discard: as it stands, these tiles win it only if you draw one.",
    readySomeNoYaku: "You are ready, but not on every one of these tiles: some give your hand no yaku as it stands.",
    pon: (tile: string) => `You can pon this ${tile}: with two of yours it makes a set of three. Your hand is then open: no riichi, and it needs a yaku that works open. You can skip it.`,
    chi: (tile: string) => `You can chi this ${tile}: with two of yours it makes a run of three. Your hand is then open: no riichi, and it needs a yaku that works open. You can skip it.`,
    kan: (tile: string) => `You can call kan on this ${tile}: with three of yours it makes a set of four, and your hand is then open.`,
    riichi: "You can declare riichi: your hand is closed and ready; you bet 1,000 points and can no longer change it.",
    win: (call: string) => `You can win this hand: press ${call}.`,
    result: "This is how the hand scored.",
  },
  landingFeatures: [
    { title: "A review that explains", text: "Every decision graded by an engine, and why, in sentences built from its numbers." },
    { title: "A table that feels real", text: "Every tile a real tile's shape: the whole wall, the dice and the deal, on a phone or a desktop." },
    { title: "A shuffle you can check", text: "Every game's walls can be verified in your own browser, against a commitment made before the deal." },
    { title: "Friends and bots", text: "Open a table for friends; bots take any empty seat." },
  ],
  navHome: "Home",
  navBoard: "Leaderboard",
  boardTitle: "Leaderboard",
  // The rank bands over the rating (design 15 §16.1 step 21; game/ranks).
  ranks: [
    { kanji: "東", name: "East" },
    { kanji: "南", name: "South" },
    { kanji: "西", name: "West" },
    { kanji: "北", name: "North" },
    { kanji: "龍", name: "Dragon" },
  ],
  rankRange: ["a rating under 500", "a rating of 500 to 699", "a rating of 700 to 899", "a rating of 900 to 1,099", "a rating of 1,100 and up"],
  boardEmpty: "No one is on the board yet: a player joins it after their five provisional ranked games.",
  boardGames: (n: number) => `${n} ${n === 1 ? "game" : "games"}`,
  boardPrevious: "Previous",
  boardNext: "Next",
  boardPlace: (n: number) => `No. ${n}`,
  boardProvisional: (n: number) => `Your rating is provisional: ${n} of 5 games played. You join the board after your fifth.`,
  provisionalShort: (n: number) => `provisional, ${n} of 5 games`,
  provisionalHint: (n: number) => `Provisional rating: ${n} of 5 games played. It settles after the fifth ranked game.`,
  ratingChart: "The rating over time",
  flairs: { "1": "#1", "3": "Top 3", "10": "Top 10", "50": "Top 50", "100": "Top 100" } as Record<string, string>,
  navHistory: "History",
  navLearn: "Learn",
  navRules: "Rules",
  menu: "Menu",
  historyTitle: "History",
  gameTitle: "A finished game",
  tableTitle: "Table",
  skipToContent: "Skip to the page",
  accuracyChart: "Accuracy over recent games",
  chartRange: (lo: string, hi: string) => `from ${lo} to ${hi}`,
  ratesNote: "Win, deal-in, riichi and opened are per hand.",
  gamesOf: (name: string) => `${name}'s games`,
  historyFilter: "Which games",
  historyFilters: { "": "All", ranked: "Ranked", bots: "Against bots", friends: "With people" } as Record<string, string>,
  historyNone: "No games yet: your games will be listed here, each with its review.",
  historyNoneHere: "No games of this kind yet.",
  historyMore: "Older games",
  reviewed: "Reviewed",
  loading: "Loading…",
  notFound: "Not found",
  signIn: "Sign in",
  signInLong: "Sign in with Google",
  signInTitle: "Sign in",
  signInKeeps: "Signing in with a new account keeps the games you played as a guest.",
  signInOr: "or",
  emailAddress: "Your email address",
  emailSend: "Mail me a sign-in link",
  emailHint: "No password: the link signs you in, once, within 15 minutes.",
  emailSent: (address: string) => `If ${address} may sign in, a link is on its way. Open it in this browser to keep what you played here.`,
  signInAgain: "Ask for another link",
  nameStepTitle: "Your name at the table",
  nameStepHint: "Other players see it. 3–20 letters, digits, spaces, - or _. You can change it, and your avatar, in Settings.",
  nameStepGo: "Continue",
  signOut: "Sign out",
  signInFailed: "Sign-in failed. The site is by invitation for now: if you have none, ask the friend who sent you here. You can play now without signing in.",
  nameHint: "3–20 letters, digits, spaces, - or _.",
  save: "Save",
  saveProfile: "Save profile",
  profile: "Profile",
  savedAsChanged: "Everything below is saved as you change it.",
  playBots: "Play against three bots",
  playRanked: "Play ranked",
  deadHand: "Dead",
  chonboTitle: (name: string) => `Chonbo: ${name} called a win that was not there. The hand is dealt again.`,
  voided: "The hand is dealt again",
  penalisedForRating: (name: string) => `${name} took a 30-point penalty: last place for the rating.`,
  rulesRankedTitle: "Ranked games and your rating",
  rulesRanked: [
    "Ranked games are played by the WRC 2025 rules on the standard clock, with no aids, against three people. An East–South game and an East only game share one rating.",
    "Your rating moves by where you finish and by whom you sat with. At a table of equal ratings an East–South game moves it +10, +3⅓, −3⅓ and −10 from first to last, an East only game two thirds of that. Each 200 points your rating stands above the table's average is worth 1 point less, each 200 below 1 point more. It never fades if you stop playing.",
    "A rating is named by its band, each 200 wide: 東 East under 500, 南 South from 500, 西 West from 700 (the middle, holding 800), 北 North from 900 and 龍 Dragon from 1,100.",
    "Your first rating comes from an assessment game: one East only game against bots, read decision by decision by the grader and held between 400 and 1,200. During your next five ranked games it is marked with a question mark: it is the average of the grader's readings so far, plus your results. After the fifth, only results move it, and you join the leaderboard.",
    "The players at your table are within 100 of the longest waiter's rating for 5 seconds, then 250 until 30 seconds, 500 until a minute, then anyone. No two players at a table share an address or a device.",
    "Leaving a ranked game does not stop it: your seat plays on by the server, and a seat the server has played for eight decisions in a row counts as last place.",
    "There are no assists, as over a table: every button is always there and nothing tells you when you can call, win or are in furiten. A call or a ron counts while the buttons are lit after someone's discard, two seconds; when you say nothing the game goes on. Tsumo, riichi and your own kan count on your turn. A press at any other moment does nothing.",
    "A press with nothing behind it is penalised by the WRC's 2025 penalties. An empty chi, pon, kan or riichi makes your hand dead: no calls, riichi or win for the rest of the hand, and noten at a draw. A win that is not there, a ron in furiten among them, is a chonbo: 30 points, and the hand is dealt again as if it never happened. A call from a dead hand costs 30 points as well. A false win while another player can really win on that tile is only a warning, and a second false win in a game makes the hand dead instead of dealing it again.",
    "A 30-point penalty is the distance from first to last, so in the rating it counts that game as last place. The final scores themselves do not change.",
  ],
  rankedIntroTitle: "Ranked",
  rankedIntroText: "Games against people, with a rating and a place on the leaderboard. Before your first one, a single assessment game against bots sets your starting rating.",
  rankedIntroButton: "About the assessment game",
  assessmentTitle: "Your assessment game",
  assessmentLead: "Before you play ranked against people, one game against bots sets your starting rating. Start it when you are ready: nothing starts until you press the button.",
  assessmentFacts: [
    { title: "What it decides", text: "An engine reads every decision you make and turns them into a starting rating between 400 and 1,200. Where you finish does not count: only your decisions do." },
    { title: "How long", text: "One East only game against three bots, about 20 to 30 minutes. Pick a time you can finish it." },
    { title: "The rules", text: "WRC 2025, 10 seconds a move plus a 20-second bank each hand." },
    { title: "No help", text: "It plays like a ranked game. Every button is always on the screen, and nothing tells you when you can call, win or are in furiten. You have two seconds to call. A press with nothing behind it is penalised: an empty chi, pon, kan or riichi makes your hand dead, and a false win is a chonbo. So that a slip costs nothing, a finger holds a button for a moment, and a keyboard holds its key." },
    { title: "If you leave", text: "A game you do not finish does not count, and you can start it again. Once you finish it, it is done: you have one." },
    { title: "What comes next", text: "Your next five ranked games are provisional: your rating shows a question mark and keeps being read. After the fifth, only results move it, and you join the leaderboard." },
  ],
  assessmentStart: "Start the assessment game",
  assessmentMore: "No help, leaving, and what comes next",
  assessmentLater: "Not now",
  assessmentAtTable: "You are at a table: finish or leave that game first.",
  assessmentTable: "Assessment game",
  assessmentTableHint: "This game sets your starting rating. It plays like a ranked game: no assists.",
  rankedTable: "Ranked",
  rankedTableHint: "This game moves your rating. No assists.",
  leaveGame: "Leave game",
  leaveGameTitle: "Leave this game?",
  leaveGameText: "It ends now and does not go into your history.",
  leaveAssessmentText: "It ends now and does not count. You will have no rating yet, and you can start the assessment game again whenever you like.",
  keepPlaying: "Keep playing",
  searching: "Searching…",
  searchingCount: (n: number) => `${n} searching`,
  botsWhileWaiting: "Play bots while you wait",
  tableReady: "Your ranked table is ready",
  tableReadyBody: "Come back to mahhua: the game is starting.",
  tableFound: "Table found. Starting…",
  joiningIn: (n: number) => `Joining in ${n}`,
  joinNow: "Join now",
  notifyAsk: "Tell you when a table forms while this tab is in the background?",
  notifyYes: "Yes",
  notifyNo: "No thanks",
  tableDidNotStart: "The table could not start: a player did not arrive. Queue again from Play.",
  rules: "Rules",
  length: "Length",
  start: "Start",
  resume: "Back to your game",
  wrc: "WRC 2025 (no red fives)",
  tenhou: "Tenhou-style (red fives)",
  east: "East only (tonpuusen)",
  eastSouth: "East–South (hanchan)",
  eastLong: "East only (tonpuusen): about 20 to 30 minutes",
  eastSouthLong: "East–South (hanchan): about 40 to 60 minutes",
  time: "Time",
  clocks: {
    standard: "Standard: 10 s a move, plus a 20 s bank each hand",
    fast: "Fast: 5 s a move, plus a 10 s bank each hand",
    relaxed: "Relaxed: 30 s a move, plus a 60 s bank each hand",
    unlimited: "No clock (a player away for 2 minutes is played for)",
  } as Record<string, string>,
  ownClock: (base: number | null, bank: number | null) =>
    base === null
      ? `${bank ?? 0} s left in your bank`
      : bank === null
        ? `${base} s to decide`
        : `${base} s for this move, then ${bank} s in your bank`,
  clocksShort: { standard: "10+20 s", fast: "5+10 s", relaxed: "30+60 s", unlimited: "No clock" } as Record<string, string>,
  clocksPlain: { standard: "10 s a move", fast: "5 s a move", relaxed: "30 s a move", unlimited: "No clock" } as Record<string, string>,
  connecting: "Connecting…",
  reconnecting: "Connection lost. Reconnecting… Nothing can be played until it's back.",
  gameGoing: "Your game is still going, and its clock is running.",
  gameGoingTurn: "It's your turn in your game.",
  doraPair: "The indicator, and the dora it points to: the next tile along.",
  nextHandIn: (s: number) => `Waiting for the others to read this result. The next hand starts in ${s} s at most.`,
  forYouAuto: "Your time ran out, so the table is playing for you. Play a tile to take your seat back.",
  forYouPlayed: "Played for you:",
  forYouAway: "While you were away, the table played for you:",
  shuffling: "Shuffling…",
  shufflingSlow: "Waiting for a player's browser to answer…",
  connectingSlow: "This is taking longer than it should. The table may not be coming: you can go back and try again.",
  gameServerDown: "The game server has stopped. Waiting for it to come back…",
  gameStopped: "The game was stopped",
  gameStoppedText: "The game server had to stop, so the game ended here. It does not count for anyone's rating or history.",
  tableStopped: "The game server stopped this table's game. It does not count for anyone's rating or history.",
  noConnection: "Can't reach the server. Check your connection and try again.",
  copyFailed: "Couldn't copy the link: select it and copy it yourself.",
  pageFailedTitle: "This page didn't load",
  pageFailed: "Something went wrong loading it, most likely the connection. Your game, if you have one, is not affected.",
  reload: "Try again",
  waiting: "Waiting for the table…",
  noGame: "You have no game running.",
  wallLeft: "left",
  dice: (d: readonly number[]) => `dice ${d[0]} and ${d[1]}`,
  honba: "honba",
  sticks: (n: number) => (n === 1 ? "riichi stick" : "riichi sticks"),
  dora: "Dora",
  auto: "auto",
  away: "away",
  bot: "bot",
  botName: "Bot",
  you: "you",
  illegal: "That move is not allowed now.",
  handEnd: "Hand over",
  tsumo: "Tsumo",
  ron: "Ron",
  draw: "Exhaustive draw",
  abortive: "Abortive draw",
  aborted: "Hand stopped by the server",
  tenpai: "tenpai",
  noten: "noten",
  fu: "fu",
  han: "han",
  yakuman: "yakuman",
  points: "points",
  pointsAll: "all",
  nagashiYou: "Nagashi mangan: you discarded only terminals and honours, and none was called. It pays as a mangan.",
  nagashi: (name: string) => `Nagashi mangan: ${name} discarded only terminals and honours, and none was called. It pays as a mangan.`,
  liableYou: "You gave the call that completed this yakuman, so you pay for it (pao).",
  liable: (name: string) => `${name} gave the call that completed this yakuman, so they pay for it (pao).`,
  close: "Close",
  gameOver: "Game over",
  finalResult: "Final result",
  place: ["1st", "2nd", "3rd", "4th"],
  finishedPlace: ["You won the game", "You came 2nd", "You came 3rd", "You came 4th"],
  score: "score",
  gameEndColumns: ["Place", "Player", "Points", "Final score"],
  handEndColumns: ["Player", "Change", "Points"],
  finalScoreNote: "Final score: your points against the return (the points each player is measured from), in thousands, plus the placement bonus (uma).",
  home: "Home",
  about: "About",
  learnTitle: "Learn to play",
  tileGuide: {
    title: "Meet the tiles",
    text: "There are 34 different tiles, four copies of each. Three suits run from 1 to 9, and seven more are honours.",
    start: "Start the lessons",
    rows: [
      { name: "Man (characters)", text: "Chinese numerals over the red 萬.", from: 0, count: 9 },
      { name: "Pin (circles)", text: "Count the circles.", from: 9, count: 9 },
      { name: "Sou (bamboo)", text: "Count the sticks. The 1 is a bird.", from: 18, count: 9 },
      { name: "Winds", text: "Honours: no numbers, and they make no runs.", from: 27, count: 4, labels: ["East", "South", "West", "North"] },
      { name: "Dragons", text: "Honours too. Three of a kind always scores.", from: 31, count: 3, labels: ["White", "Green", "Red"] },
    ] as { name: string; text: string; from: number; count: number; labels?: string[] }[],
  },
  learn: {
    intro: "Short lessons on real hands. Each asks you for one move; make it on the table.",
    lesson: (n: number, of: number) => `Lesson ${n} of ${of}`,
    right: "Right.",
    tryAgain: "Not quite. ",
    next: "Next lesson",
    finish: "Finish",
    all: "All lessons",
    start: "Start the lessons",
    goOn: (title: string) => `Go on: ${title}`,
    again: "Start them again",
    overview: "Ten short lessons on real hands. Each asks you for one move; you make it on the table.",
    tilesHead: "Meet the tiles",
    back: "Previous",
    leave: "Leave the lessons",
    firstGame: "Play your first game",
    done: "Play a game",
    doneText: "That is the game: build four sets and a pair, call when it helps, declare riichi when you can, and watch for danger. The rules page lists every yaku.",
    lessons: {
      goal: {
        title: "Four sets and a pair",
        text: "A winning hand is four sets (three in a row of one suit, or three of a kind) and a pair. You hold 1-2-3 man, 4-5-6 pin, 3-4-5 sou, 7-8 sou waiting for a third, and a pair of 9 pin. You just drew the North wind. Discard a tile.",
        why: "The North belongs to nothing in your hand. Without it you are one tile from winning: a 6 or 9 sou completes the hand.",
        hint: "Look for the tile that fits no set and no pair.",
      },
      pon: {
        title: "Calling pon",
        text: "Across discarded a red dragon, and you hold two. Taking a discard to make three of a kind is a pon. Three red dragons are a yaku: a scoring pattern, which every winning hand needs.",
        why: "Pon. Your hand is now open (the triplet is shown), and it already has its yaku.",
        hint: "You have a pair of that tile: call it.",
      },
      chi: {
        title: "Calling chi",
        text: "The player on your left discarded the 6 pin, and you hold 4-5 pin. Taking a discard to make a run is a chi, and only the discard of the player on your left can be taken for one.",
        why: "Chi: 4-5-6 pin is a set. Calling opens your hand, which rules out riichi, so call when it helps more than it costs.",
        hint: "The 6 pin finishes a run with tiles you hold.",
      },
      riichi: {
        title: "Riichi",
        text: "Your hand is concealed (no calls) and, once the East goes, one tile from winning. Declaring riichi bets 1,000 points that you will win; it is a yaku by itself, and the hand can no longer change.",
        why: "Riichi. Your tile lies sideways, and from now on every tile you draw goes by itself unless it wins or makes a kan.",
        hint: "Use the Riichi button, then choose the tile: you are ready and concealed.",
      },
      ron: {
        title: "Winning on a discard: ron",
        text: "You are waiting on a 2 or 5 sou, and the player on your right just discarded the 5 sou.",
        why: "Ron. The discarder pays for the whole hand: 1,500 points here.",
        hint: "That tile completes your hand: claim the win.",
      },
      tsumo: {
        title: "Winning on your draw: tsumo",
        text: "Same hand, and this time you drew the 2 sou yourself.",
        why: "Tsumo. All three others pay, 700 points each here. A concealed hand that wins on its own draw also scores menzen tsumo, one more yaku.",
        hint: "The tile you drew completes your hand.",
      },
      yaku: {
        title: "Every win needs a yaku",
        text: "A complete hand can't win without a yaku, a scoring pattern. Three easy ones: riichi; three of a dragon, as in the pon lesson; and tanyao, a hand with no 1s, 9s or honours. Every tile here is from 2 to 8, and you just drew the 9 pin. Discard a tile.",
        why: "Tanyao: all your tiles are from 2 to 8, and it works open or concealed. Calling is fine when the hand still has a yaku like this one. An open hand with none can't win at all.",
        hint: "Keep every tile between 2 and 8.",
      },
      safe: {
        title: "Playing safe",
        text: "Across declared riichi (their sideways tile) and is waiting to win; your hand is far from ready. A player cannot win on a tile they discarded themselves, so their own discards are safe for you.",
        why: "Safe: they discarded that tile, so they cannot win on it. Dealing into a riichi hand is often the costliest mistake.",
        hint: "Look at what Across has discarded: you hold two of those tiles.",
      },
      dora: {
        title: "Dora",
        text: "In the middle of the table are the indicator, then the dora it points to: the next tile along. Here the indicator is the East, so the South is the dora. Each dora you hold when you win is one more han. It adds value, but it is no yaku. You hold a South and just drew a West. Discard a tile.",
        why: "Keep the dora. Winds run East, South, West, North and back; dragons White, Green, Red and back; a suit's 9 is followed by its 1.",
        hint: "One of your two winds is worth a han. Let the other go.",
      },
      noron: {
        title: "When there is no Ron button",
        text: "You are ready on a 2 or 5 sou, and Left has discarded the 2 sou, yet you are not offered a win. You discarded a 5 sou yourself: a hand that has thrown one of its own winning tiles is furiten, and cannot win on a discard. A win needs a yaku too, and a hand with none is offered nothing either. What now?",
        why: "Skip. Furiten stays until your wait changes; you can still win on a tile you draw.",
        hint: "Calling this breaks a hand that is ready. Skip it.",
      },
    } as Record<string, { title: string; text: string; why: string; hint: string }>,
  },
  rulesTitle: "Rules and yaku",
  rulesJumpYakuman: "Yakuman",
  rulesJumpDora: "Dora",
  rulesJumpWords: "Words",
  rulesJump: "Jump to",
  rulesWords: "Words you'll meet",
  glossary: [
    { id: "yaku", term: "Yaku", kanji: "役", text: "A scoring pattern. A winning hand needs at least one, however complete it is. Dora add value but aren't yaku." },
    { id: "han", term: "Han and fu", kanji: "翻・符", text: "What a hand scores: han from its yaku and dora, fu from its shape. Together they set its value." },
    { id: "tenpai", term: "Tenpai", kanji: "聴牌", text: "Ready: one tile from winning." },
    { id: "shanten", term: "Shanten", kanji: "向聴", text: "How many tiles a hand is from tenpai. 1-shanten is one tile away from being ready." },
    { id: "furiten", term: "Furiten", kanji: "振聴", text: "You can't win on a discard if one of your waits is in your own river, or you passed on a win since your last turn. You can still win on your own draw." },
    { id: "deal-in", term: "Deal in", kanji: "放銃", text: "To discard the tile another player wins on. You then pay for their whole hand." },
    { id: "tsumogiri", term: "Tsumogiri", kanji: "ツモ切り", text: "Discarding the tile you just drew. A darker tile in a river shows it: a little about what that player holds." },
    { id: "honba", term: "Honba and riichi sticks", kanji: "本場・供託", text: "A honba counter adds 300 points to a win, and comes when a dealer wins or a hand is drawn. A riichi stick is a 1,000-point bet on the table: the next win takes them." },
    { id: "bank", term: "The bank", text: "Your clock is seconds a move, then a bank that is spent across the hand. The bank is never spent on a call." },
    { id: "placement-points", term: "Placement points", text: "What the review measures: where you finish, in points, with a bonus for finishing high. A decision that loses 1.5 of them makes that much difference to where you'd expect to finish." },
    { id: "accuracy", term: "Accuracy", text: "How close your decisions came to the engine's, across the game: 100 would be all of them." },
  ],
  rulesIntro: [
    "A winning hand is four sets and a pair (or seven pairs, or the thirteen orphans), and it needs at least one yaku: a pattern from the list below. Dora add han but are not yaku.",
    "The han of every yaku and dora, with the fu of the hand's shape, set its value; from 5 han the value is a limit (mangan, haneman, baiman, sanbaiman); 13 han or more counts as a yakuman under Tenhou rules (kazoe yakuman) and as yonbaiman under WRC rules.",
    "Some yaku need a concealed hand; others are worth one han less once the hand is open. Riichi needs a concealed hand ready to win.",
  ],
  rulesRiver: "On the table, a darker tile in a player's discards is one they threw straight after drawing it: a little about what they hold.",
  rulesYaku: "Yaku",
  rulesConcealed: "Concealed",
  rulesOpen: "Open",
  rulesClosedOnly: "concealed only",
  rulesHan: (n: number) => `${n} han`,
  rulesYakuman: "Yakuman (a limit hand by itself; two count double)",
  rulesDora: "Dora (not yaku): one han per tile",
  rulesTanyao: "Open tan'yao (kuitan) counts where the rules allow it.",
  yakuHelp: {
    1: "Declared with a concealed, ready hand, for 1,000 points.",
    2: "Won within one go-around of riichi, with no call in between.",
    3: "A concealed hand won on your own draw.",
    4: "All runs, a pair of no value, and a wait on either side of a run.",
    5: "Two identical runs, concealed.",
    6: "Only 2 to 8: no terminals, no honours.",
    7: "Three of a kind in white dragons.",
    8: "Three of a kind in green dragons.",
    9: "Three of a kind in red dragons.",
    10: "Three of a kind in your own wind.",
    11: "Three of a kind in the round's wind.",
    12: "Won on the tile another player adds to make a kan.",
    13: "Won on the replacement tile drawn after a kan.",
    14: "Won on the very last tile of the wall, drawn.",
    15: "Won on the very last discard.",
    16: "Riichi on your very first discard, with no call before it.",
    17: "Seven different pairs. The one hand of no four sets.",
    18: "1 to 9 in one suit, as three runs.",
    19: "The same run in all three suits.",
    20: "The same three of a kind in all three suits.",
    21: "Four sets of three of a kind.",
    22: "Three of a kind, three times, none from a discard.",
    23: "Three kans.",
    24: "Every set and the pair hold a terminal or an honour.",
    25: "Only terminals and honours.",
    26: "Two dragon sets and a pair of the third.",
    27: "Two pairs of identical runs, concealed.",
    28: "One suit and honours.",
    29: "Every set and the pair hold a terminal, with no honours.",
    30: "Won on a discard before your first draw.",
    31: "One suit alone.",
    40: "The dealer wins on the deal.",
    41: "A non-dealer wins on their first draw.",
    42: "One of each terminal and honour, and a pair of one.",
    43: "1112345678999 in one suit, and any tile of it.",
    44: "Only green tiles: 2, 3, 4, 6, 8 sou and the green dragon.",
    45: "Four sets of three of a kind, none from a discard.",
    46: "Four kans.",
    47: "Only terminals.",
    48: "Only honours.",
    49: "Three of a kind in all three dragons.",
    50: "Three wind sets and a pair of the fourth.",
    51: "Three of a kind in all four winds.",
    60: "Each tile matching the tile after an indicator.",
    61: "As dora, from the indicators beneath them, after a riichi win.",
    62: "Each red five.",
  } as Record<number, string>,
  aboutAlpha: "mahhua is a Riichi mahjong site: ranked and friendly play, and a review of every game in plain words. It is in its first test.",
  privacyTitle: "Privacy",
  privacy: [
    "What the site keeps about you: your Google account's identifier, and the email address you were invited by or sign in with (used only to sign you in), your display name and avatar, your sign-in sessions, your friends and friend requests, and the tables and games you played, with how long each of your decisions took.",
    "It keeps nothing else from Google: no name, photo, contacts or Google token beyond the sign-in itself. There is no advertising, no analytics and nothing loaded from other sites. Everything you do here is public, to anyone, signed in or not: your display name and avatar, your counts, your friends, whether you are online, and every game you finish with its replay. Your settings, your email address and your pending friend requests are yours alone; your email address is never shown. A review of a game is shown to that game's players.",
    "If you play as a guest, without signing in, the site keeps your games and a hash of your address (to limit how many guest tables one address opens), and deletes them after 30 days unless you sign in.",
    "If you play ranked games, the site keeps a hash of your address and of a mark on your browser for each of them, for 24 months: to keep two people on one address or device from one table, and for fair play. It cannot read your address back from the hash.",
    "To have your account deleted, ask the person who invited you: your name and sign-in are removed; your games stay in the other players' histories under an anonymous id.",
  ],
  creditsTitle: "Credits",
  credits:
    "Tiles: FluffyStuff's riichi-mahjong-tiles (Regular), dedicated to the public domain under CC0 1.0. The logo's 話 is set in Noto Serif JP, and the titles in Source Serif 4 and Noto Serif JP (SIL Open Font License 1.1). Thank you.",
  settings: "Settings",
  displayName: "Display name",
  avatar: "Avatar",
  atATable: "You have a game going. Finish or leave it to start another.",
  atOpenTable: "Your table is open. Close or leave it to start another.",
  backToTable: "Back to your table",
  openTable: "Open a table for friends",
  friendsTables: "Friends' tables",
  gameOptions: "Options",
  recentGames: "Recent games",
  placesTitle: "Places finished",
  allGames: "All games",
  view: "Open",
  friends: "Friends",
  friendName: "A friend's display name",
  addFriend: "Add",
  nowFriends: "You are now friends.",
  requestSent: "Request sent.",
  wantsToBeFriends: "wants to be friends",
  accept: "Accept",
  decline: "Decline",
  requested: "request sent",
  cancel: "Cancel",
  noFriends: "No friends yet: add one by display name.",
  presence: { online: "online", playing: "playing", offline: "offline" } as Record<string, string>,
  wrcShort: "WRC 2025",
  tenhouShort: "Tenhou-style",
  eastShort: "East only",
  eastSouthShort: "East–South",
  table: "Table",
  host: "host",
  botWillPlay: "Empty: a bot will play",
  inviteLink: "Invite link",
  copyLink: "Copy link",
  copied: "Copied",
  shareLink: "Anyone with this link can join while the table is open.",
  join: "Join",
  startGame: "Start",
  leave: "Leave",
  closeTable: "Close table",
  waitingForHost: "Waiting for the host to start.",
  alreadyAtTable: "You are already at another table.",
  noSuchTable: "There is no such table.",
  noSuchPage: "There is no such page.",
  guestsFull: "Too many people here are playing without an account. Sign in to play, it takes a moment.",
  inProgress: "A game is being played at this table.",
  tableEnded: "This table's game has ended.",
  tableClosed: "This table was closed.",
  watchReplay: "Replay",
  noSuchProfile: "This profile is not visible to you.",
  joined: "Joined",
  games: "Games",
  avgPlace: "Average place",
  winRate: "Win",
  dealInRate: "Deal-in",
  riichiRate: "Riichi",
  openRate: "Opened",
  pastGames: "Past games",
  noGames: "No finished games yet.",
  replay: "replay",
  noSuchGame: "This game doesn't exist, or isn't visible to you.",
  startYourOwn: "Start your own game",
  signInToSee: "Sign in to see this page.",
  stillTrying: "Can't reach the server yet. Still trying…",
  aids: "Play aids",
  aidHelp: {
    hints: "Short notes at the table on what you can do, the first times it comes up.",
    auto_win: "Takes a win as soon as you can.",
    skip_calls: "Passes on chi, pon and kan without asking.",
    tsumogiri: "Discards each tile you draw, unless it offers something.",
    auto_sort: "Keeps your hand in order.",
    sound: "Tiles, calls and your turn.",
  } as Record<string, string>,
  aidsHint: "All of these are for unranked tables. With auto-sort off, drag a tile sideways to move it.",
  saved: "Saved.",
  previewDiscard: "Show a discard",
  previewBack: "Show the hand again",
  aidNames: { auto_win: "Auto-win", skip_calls: "Skip calls", tsumogiri: "Tsumogiri", auto_sort: "Auto-sort", hints: "Hints for a first game", sound: "Sound" } as Record<string, string>,
  volume: "Volume",
  motion: "Table",
  feel: "How tiles move",
  feels: { weighty: "Weighty", brisk: "Brisk", gentle: "Gentle", instant: "Instant" } as Record<string, string>,
  feelHint: "Weighty: tiles have mass and settle. Brisk: they move quicker. Gentle: slower, for watching. Instant: no travel. The time you have to play is set when you start a game.",
  boardView: "The board",
  views: { auto: "For this screen", top: "The whole table", compact: "Compact" } as Record<string, string>,
  viewHint: "The whole table, the wall included; or without the wall, the tiles larger. For this screen: compact on a phone, the whole table elsewhere.",
  angle: "Seen from",
  angleHint: (deg: number) => (deg === 0 ? "Straight above, as a diagram." : `${deg}° back from straight above: the further back, the lower you sit and the more of each tile's side you see.`),
  drawn: "Your drawn tile",
  drawnPlaces: { apart: "Apart at the right", on_top: "Sideways on top of the hand" } as Record<string, string>,
  drawnHint: "The other players see it where you lay it. From your next table.",
  haptics: "Haptics",
  hapticsHint: "On phones that have them: a light pulse as your tile lands, on your calls and wins, and as your last seconds begin.",
  soundHint: "Sounds for discards, calls, riichi, wins, your turn and your last seconds.",
  tableReadySound: "\"Table ready\" sound",
  tableReadyHint: "Plays when a ranked table forms, whether or not the sounds above are on.",
  say: {
    hand: (round: string, n: number, dealer: string) => `${round} ${n}, dealer ${dealer}`,
    discards: (who: string, tile: string) => `${who} discard${who === "you" || who === "You" ? "" : "s"} ${tile}`,
    riichi: (who: string, tile: string) => `${who} declare${who === "you" || who === "You" ? "" : "s"} riichi, discarding ${tile}`,
    called: (who: string, call: string, tiles: string) => `${who}: ${call}, ${tiles}`,
    drew: (tile: string) => `You drew ${tile}`,
    yourTurn: "Your turn",
    canCall: (names: string) => `You can: ${names}`,
    wins: (who: string, how: string) => `${who}: ${how}`,
    handOver: (scores: string) => `The hand is over. ${scores}`,
    turnOf: (who: string) => `${who} to play`,
    handIs: (tiles: string) => `Your hand: ${tiles}`,
    waits: (kinds: string) => `Waiting on ${kinds}`,
    noHand: "No hand is being played.",
    discardsOf: (who: string) => `${who}'s discards`,
    meldsOf: (who: string) => `${who}'s calls`,
    yourDiscards: "Your discards",
    yourMelds: "Your calls",
    none: "none",
  },
  keysTitle: "Keys at the table",
  keys: [
    "Tab, or the arrows once in the hand: go along your tiles. Enter or Space on one discards it.",
    "Enter with nothing chosen: discards the tile you drew.",
    "Shift and an arrow, with auto-sort off: moves a tile.",
    "T tsumo · R ron or riichi · P pon · K kan · C chi, then 1, 2, 3 if there are several.",
    "Space or Esc: skip.",
    "L: says how the table stands, for a screen reader.",
    "? shows this list.",
  ],
  keysNoAssist: [
    "Tab, or the arrows once in the hand: go along your tiles. Enter or Space on one discards it.",
    "Hold, for a moment: T tsumo · R riichi on your turn, ron on a discard · P pon · K kan · C chi, then 1, 2, 3 if there are several.",
    "Space or Esc: skip.",
    "L: says how the table stands, for a screen reader.",
    "? shows this list.",
  ],
  shortcuts: "Keys: Space or Esc skip · T tsumo · R ron or riichi · P pon · C chi · K kan · Enter discards the drawn tile, or presses what has the focus",
  furiten: "Furiten",
  allHands: "All hands",
  waits: "Waits",
  superseded: "This game is open in another tab.",
  playHere: "Play here",
  gameDissolved: "The game could not start: a player's browser did not answer in time. The table is open again.",
  gameDissolvedAway: (names: string) => `The game could not start: ${names} didn't answer. Ask them to come back, or give their seat to a bot.`,
  seatToBot: "Give the seat to a bot",
  tableFull: "This table is full.",
  learnWhileWaiting: "New to riichi? Try the lessons while you wait: you'll be brought back when the game starts.",
  serverError: "The game hit a server error and has to stop.",
  deletedPlayer: "Deleted player",
  prevHand: "Previous hand",
  nextHand: "Next hand",
  prevStep: "Back",
  nextStep: "Forward",
  play: "Play",
  pause: "Pause",
  position: "Position",
  verifying: "Checking the shuffle…",
  verified: "✓ Verified",
  verifiedMine: "The deal was fixed before your browser added its random number, that number is at your seat, and every wall and event replays exactly as signed.",
  verifiedOther: "Every wall and event replays exactly as signed, from the record's commitment. (Only a player's own browser can also check that the commitment came before its random number.)",
  unverifiable: "Not verifiable",
  unverifiableWhy: "This game was ended by the server: its walls cannot be checked against a commitment.",
  verifyFailed: "⚠ Verification failed",
  verifyFailedWhy: "This record does not check out. Please report it with this game's link:",
  verifyError: "Could not check the shuffle right now.",
  retried: "The start was retried once because a seat's random number was late.",
  retriedReceived: "Your browser's number for the first start had been received (this browser keeps the server's signed receipt), so the late seat was not yours.",
  rounds: ["East", "South", "West", "North"],
  winds: ["E", "S", "W", "N"],
  // The game's own words, beside the English (design 15 §1.1): the winds and the round as every riichi table writes them.
  windsKanji: ["東", "南", "西", "北"],
  roundKanji: (round: number, n: number) => `${["東", "南", "西", "北"][round] ?? ""}${n}局`,
  actions: {
    CHI: "Chi",
    PON: "Pon",
    OPEN_KAN: "Kan",
    ADDED_KAN: "Kan",
    CLOSED_KAN: "Kan",
    RON: "Ron",
    TSUMO: "Tsumo",
    PASS: "Skip",
    DECLARE_RIICHI: "Riichi",
    CHONBO: "Chonbo",
    DEAD_HAND: "Dead hand",
    FINE: "30 points",
    WARNING: "Warning",
    ABORTIVE_DRAW: "Nine terminals",
    TAKE_LAST_TILE: "Take last tile",
  } as Record<string, string>,
  // A call as the table calls it (design 15 §1.1), the English beneath it; a penalty has no word of its own and is called in English.
  callsKana: {
    CHI: "チー",
    PON: "ポン",
    OPEN_KAN: "カン",
    ADDED_KAN: "カン",
    CLOSED_KAN: "カン",
    RON: "ロン",
    TSUMO: "ツモ",
    DECLARE_RIICHI: "リーチ",
    CHONBO: "チョンボ",
  } as Record<string, string>,
  aborts: ["", "Nine terminals", "Four winds", "Four riichi", "Four kans", "Triple ron"],
  limits: {
    mangan: "Mangan",
    haneman: "Haneman",
    baiman: "Baiman",
    sanbaiman: "Sanbaiman",
    yonbaiman: "Yonbaiman",
    kazoe: "Kazoe yakuman",
    yakuman: "Yakuman",
  } as Record<string, string>,
  multiples: ["", "", "Double ", "Triple ", "Quadruple ", "Quintuple ", "Sextuple "],
  doraIndicators: "Dora indicators",
  uraIndicators: "Ura indicators",

  // The review (design 12).
  review: "Review",
  reviewThisGame: "Review this game",
  playAgain: "Play again",
  rematch: "Rematch",
  rematchAsked: (name: string, ready: number) => `Rematch · ${name} asked · ${ready}/4 ready`,
  rematchWaiting: (ready: number) => `Waiting for other players · ${ready}/4 ready`,
  rematchEnds: {
    declined: (name: string) => `Rematch cancelled: ${name} declined.`,
    withdrawn: (name: string) => `Rematch cancelled: ${name} withdrew it.`,
    ranked: (name: string) => `Rematch cancelled: ${name} started a ranked game.`,
    table: (name: string) => (name ? `The rematch did not start: ${name} is at another table.` : "The rematch did not start: a player is at another table."),
    address: () => "The rematch did not start: two players share an address or a device, which a rated table does not allow.",
    failed: () => "The rematch did not start: the game server is unavailable.",
  } as Record<string, (name: string) => string>,
  rematchAccepted: "Accepted",
  rematchPending: "Waiting",
  playRankedAgain: "Play ranked again",
  presenceEnd: { here: "Still here", elsewhere: "Elsewhere on mahhua", gone: "Gone" } as Record<string, string>,
  ratingReading: "Your rating is being read…",
  firstRating: (rating: string) => `Your first rating: ${rating}`,
  firstRatingShort: (rating: string) => `first rating ${rating}`,
  firstRatingAfter: "You can play ranked now.",
  flairGained: (flair: string) => `You entered the ${flair}.`,
  flairTook: "You took #1.",
  flairLost: (flair: string) => `You left the ${flair}.`,
  theirFlairGained: (name: string, flair: string) => `${name} entered the ${flair}.`,
  theirFlairLost: (name: string, flair: string) => `${name} left the ${flair}.`,
  flairNames: { "1": "#1", "3": "top 3", "10": "top 10", "50": "top 50", "100": "top 100" } as Record<string, string>,
  rematchClosed: "The rematch has started or closed.",
  reviewRetry: "Review again",
  reviewing: (s: number | null) => (s === null ? "Reviewing…" : `Reviewing… ${s} s`),
  reviewFailed: (reason: string) =>
    ({ guest: "A guest has one review: sign in for more.", busy: "The server is busy: try again in a moment.", unavailable: "Reviews are not available on this server.", invalid: "This game cannot be reviewed." })[reason] ??
    "The review failed: try again.",
  summary: "Review summary",
  reviewTitle: "Game review",
  accuracy: "Accuracy",
  finished: (place: number, pts: string) => `finished ${["1st", "2nd", "3rd", "4th"][place - 1] ?? place} with ${pts} points`,
  classCount: (c: string, n: number) =>
    n === 1 ? ({ best: "Best", good: "Good", inaccuracy: "Inaccuracy", mistake: "Mistake", blunder: "Blunder" } as Record<string, string>)[c]! : ({ best: "Best", good: "Good", inaccuracy: "Inaccuracies", mistake: "Mistakes", blunder: "Blunders" } as Record<string, string>)[c]!,
  lossPts: (x: string) => `${x} pts`,
  tooFew: "Too few decisions for an accuracy",
  graded: (n: number) => `${n} decision${n === 1 ? "" : "s"} graded`,
  classes: { best: "Best", good: "Good", inaccuracy: "Inaccuracy", mistake: "Mistake", blunder: "Blunder" } as Record<string, string>,
  gameLine: "Your expected placement points through the game",
  gameLineNote: "Your expected placement points through the game, as the engine saw them; the marks are your inaccuracies, mistakes and blunders.",
  keyMoments: "Key moments",
  handNo: (n: number) => `Hand ${n}`,
  gradedBy: "Graded by a provisional engine: grades will be redone by a stronger one.",
  startReview: "Go to the first decision",
  decision: "Decision",
  isBest: "The engine's choice",
  nearBest: "As good as the engine's choice",
  lost: (x: string) => `Lost ${x} placement points`,
  why: "Why?",
  previous: "Previous",
  next: "Next",
  prevDecision: "Previous decision",
  nextDecision: "Next decision",
  nextMistake: "Next mistake",
  prevMistake: "Previous mistake",
  everyDecision: "Every decision",
  youChose: (x: string) => `You: ${x}`,
  bestWas: (x: string) => `Best: ${x}`,
  action: "Action",
  lossHeader: "Grade",
  expectedTitle: (x: string) => `Expected placement points after this action: ${x}`,
  winOdds: "Win",
  dealInOdds: "Deal-in",
  handValue: "Hand",
  handValueTitle: "The points the engine expects from this hand: what it wins less what it deals in",
  allActions: (n: number) => `All ${n} actions`,
  fewerActions: "Fewer actions",
  discardOf: (tile: string) => `Discard ${tile}`,
  // The computed reasons (design 12 §6): fixed templates, every number computed.
  safety: { genbutsu: "genbutsu (it cannot ron it)", suji: "suji", noChance: "no-chance", unsafe: "not safe" } as Record<string, string>,
  reasonSafety: (who: string, b: string, sb: string, pb: string, c: string, sc: string, pc: string) =>
    `Against ${who}'s riichi, ${b} was ${sb}: deal-in risk ${pb}; ${c} was ${sc}: ${pc}.`,
  reasonDealIn: (b: string, pb: string, c: string, pc: string) => `Deal-in risk: ${pb} with ${b}, ${pc} with ${c}.`,
  reasonShanten: (b: string, sb: string, c: string, sc: string) => `${b} kept you ${sb}; ${c} took you back to ${sc}.`,
  reasonUkeire: (b: string, ub: number, c: string, uc: number, s: string) =>
    `Both keep you ${s}, but ${b} leaves ${ub} tiles that improve the hand and ${c} only ${uc}.`,
  inFavourOf: (c: string, text: string) => `In favour of ${c} — ${text.charAt(0).toLowerCase()}${text.slice(1)}`,
  reasonShantenAgainst: (c: string, sc: string, b: string, sb: string) => `${c} took you to ${sc}, ${b} keeps you ${sb}: the engine gives up speed here.`,
  reasonUkeireAgainst: (c: string, uc: number, b: string, ub: number, s: string) =>
    `Both keep you ${s}, and ${c} leaves more tiles that improve the hand than ${b} (${uc} against ${ub}): the engine weighs the rest more.`,
  reasonWin: (b: string, pb: string, c: string, pc: string) => `Chance to win this hand: ${pb} with ${b}, ${pc} with ${c}.`,
  reasonValue: (b: string, vb: number, c: string, vc: number) =>
    `The engine expects ${vb >= 0 ? "+" : "−"}${Math.abs(vb).toLocaleString("en")} points from this hand with ${b}, ${vc >= 0 ? "+" : "−"}${Math.abs(vc).toLocaleString("en")} with ${c}.`,
  reasonPlacement: (b: string, fb: string, lb: string, c: string, fc: string, lc: string) =>
    `For the game: with ${b} the engine sees you first ${fb} of the time and last ${lb}; with ${c}, first ${fc} and last ${lc}.`,
  reasonNear: (b: string, c: string, x: string) => `${b} and ${c} are almost the same to the engine (within ${x} placement points).`,
  reasonOther: (b: string, x: string) => `The engine prefers ${b} by ${x} placement points, for the table as a whole: the scores, the other hands, what comes next.`,
  shantenWords: (n: number) => (n <= 0 ? "tenpai" : `${n}-shanten`),
  // How the hand stands (design 12 §6): what is true, never what to do.
  asItStands: "As it stands",
  standKinds: (names: string[]) => (names.length < 2 ? names.join("") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`),
  standOn: (points: number, name: string) => `${points.toLocaleString("en-US")} on ${name}`,
  standWin: (points: number, riichi: boolean) => `This win pays ${points.toLocaleString("en-US")}${riichi ? ", before any ura" : ""}.`,
  standDora: (tile: string, han: number) => `${tile[0]!.toUpperCase()}${tile.slice(1)} is dora: worth ${han === 1 ? "a" : han} han if it is in the winning hand.`,
  standSafe: (tile: string, seat: string) => `${tile[0]!.toUpperCase()}${tile.slice(1)} cannot deal in to ${seat}'s riichi: that seat cannot win on it by ron.`,
  standWaits: (action: string, n: number, names: string, left: number) => `After ${action}, the hand waits on ${n === 1 ? "one kind" : `${n} kinds`}, ${names}, with ${left} left.`,
  standCallWaits: (action: string, names: string) => `After ${action} and a discard, the hand can wait on ${names}.`,
  standCallManyWaits: (action: string, n: number) => `After ${action} and a discard, the hand can wait on any of ${n} kinds, depending on the discard.`,
  standDead: (name: string) => `All four ${name} are visible: that wait has no tiles left.`,
  standFuriten: (names: string) => `It is furiten on ${names}: it cannot win on a discard.`,
  standNoYaku: (n: number) => `As it stands it has no yaku: ${n === 1 ? "that tile would not" : "none of those tiles would"} win it.`,
  standNoRon: (riichi: boolean) => `As it stands it has no yaku on a discard: it can win only on a tile it draws${riichi ? ", or with riichi" : ""}.`,
  standSomeNoYaku: (names: string) => `As it stands ${names} ${names.includes(" and ") ? "have" : "has"} no yaku.`,
  standWorth: (on: string[], riichi: boolean) => `It is worth, as it stands: ${on.join(", ")}, before ${riichi ? "ura, " : ""}honba and deposits.`,
  standWorthTsumo: (on: string[]) => `On a draw: ${on.join(", ")}, before honba and deposits.`,
  standWorthRiichi: (on: string[]) => `With riichi: ${on.join(", ")}, before ura and ippatsu.`,
  theTile: (tile: string) => `the ${tile}`,
  honourNames: ["East wind", "South wind", "West wind", "North wind", "White dragon", "Green dragon", "Red dragon"],
  chiShapes: ["low", "middle", "high"],
  win: "Win",
};

